//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stepTitle from "../StepTitle";
import { api, config } from '@/service';

export default {
    props: {
      data: {
          default: () => []
      },
    },
    data() {
        /**
         * @method checkPhone 檢測手機號
         */
        let checkPhone = (rule, value, callback, errorText) => {            
            if(!this.phone) callback(new Error('請選擇上台方式'))
            else if(this.phone == 1 && !this.input[0]) callback(new Error('請選擇新的電話號碼'))
            else callback()
        }
        return {
            form: {},
            phone: '1', // 上台号码    
            input: ['', '臨時號碼'],
            dialog: {
                show: false,
                data: [],
                page: 0
            },
            rules: {
                phone: [
                    { required: true, validator: checkPhone, trigger: 'change' }        
                ],
            }
        }
    },
    created() {
        this.init()
    },
    watch: {
        'input': function(n, o) {            
            this.emitInput()
        }
    },
    methods: {
        toPosition(dom) {
            let { offsetTop } = dom
            window.scroll(0, offsetTop)
        },
        emitInput() {
            this.$emit('phone-change', this.input[this.phone - 1])
        },
        handleChange(params) {            
          // console.log(params, 84);
            this.$refs.broadbandWayForm.clearValidate('phone')
            this.emitInput()        
        },
        handleClick(params) {       
            this.input[0] = params
            this.phone = '1'
            return this.$http('msisdnPreempt', {
              msisdn: params,
              dnType: '0', // 0：固网号码 1：移动号码(后付费号码) 2：物联网号码 3：一卡多号号码
              orgId: this.$client.orgid,
              userId: this.$client.userid,
          }).then(res=>{
                if(res && res.returnCode == 1000) {
                    this.dialog.show = false
                    this.emitInput()
                } else {
                  return this.$message({ customClass: this.$device, showClose: true, message: '家具電話預佔失敗', type: 'warning' });
                }
            })            
            
        },
        toggle() {
            this.dialog.show = !this.dialog.show
            if(this.dialog.show && !this.dialog.data.length) this.getPhoneList()
        },
        getPhoneList() {
            this.dialog.page += 1
            this.dialog.data = []
            this.$http('phoneBoss', {
                type: 0,
                pageNumber: this.dialog.page,
                pageSize: this.$device === 'pc' ? 25 : 10                
            }).then(res=>{
                if(res.returnCode == '1000') this.dialog.data = res.records                
            })
        },
        init() {        
            let { registerType } = this.data
            if(registerType.length) registerType.forEach(() => this.input.push(''))            
        },       
        getForm() {
            let temp;
            this.$refs.broadbandWayForm.validate(async (valid, object) => {
                if (valid) {
                    let tregisterType = this.phone
                    temp = {
                        homePhoneType: this.phone,
                        homePhone: this.input[this.phone - 1],
                    }
                }
                else {                
                    for(let i in object) {
                        let target = this.$refs[i];                        
                        if(target) {
                            this.toPosition(target.$el)
                            break;
                        }
                    }
                    temp = '家居電話信息有誤'
                }
            })
            return temp
        }
    },
    components: {
        stepTitle
    }
}
